import { color, rem, radius, spacing } from '@thiememeulenhoff/lit-sdk';
import { css, CSSResult, unsafeCSS } from 'lit';
import {
  ContentMessageType,
  ContentMessageTypes,
} from '@thiememeulenhoff/types';
import { tagName } from '../../helpers';
import {
  contentMessageColors,
  contentMessageTints,
} from './content-message.types';

export const tag = tagName('content-message');

const contentMessageTypeStyle = (contentMessageType: ContentMessageType) => {
  const selector = unsafeCSS(`[type=${contentMessageType}]`);
  const iconClass = unsafeCSS(`.content-message-icon-${contentMessageType}`);
  const iconColor = contentMessageColors[contentMessageType];
  const tint = contentMessageTints[contentMessageType];

  return css`
    :host(${selector}) {
      border-color: ${color(iconColor, tint)};
      a-icon {
        color: ${color(iconColor, tint)};
      }
      .header {
        font-weight: bold;
      }
    }

    ${iconClass} {
      color: ${color(iconColor, tint)};
    }
  `;
};

const styles: Array<CSSResult> = [];

styles.push(css`
  :host {
    background: ${color('beige', 100)};
    border-radius: ${radius('medium')};
    box-sizing: border-box;
    color: ${color('grey', 900)};
    display: flex;
    flex-direction: column;
    gap: ${spacing(50)};
    inline-size: 100%;
    padding: ${spacing(150)};
  }

  .header-container {
    align-items: center;
    display: flex;
    gap: ${spacing(100)};
  }

  .time-information {
    color: ${color('grey', 600)};
    display: block;
    font-size: ${rem(14)};
    margin-block-end: ${spacing(100)};
  }

  .content-message {
    border-inline-start: ${rem(2)} solid;
    color: ${color('grey', 900)};
    margin-inline-start: ${spacing(50)};
    padding-inline-start: ${spacing(100)};
  }
`);

ContentMessageTypes.forEach((type: ContentMessageType) =>
  styles.push(contentMessageTypeStyle(type)),
);

export const contentMessageStyles = styles;
